jQuery(function ($) {
    const $root = $('body');

    // COPY CURRENT PAGE LINK (wheel) - reuse UniversalHelpers.copyToClipboard
    const $copyWrapper = $(".single-wheel-page .copy-current-url-wrapper");
    const $copySuccess = $copyWrapper.find(".copy-status-success");
    const $copyError = $copyWrapper.find(".copy-status-error");

    $root.on("click", ".single-wheel-page .single-car-hero-button-copy-url", function (e) {
        e.preventDefault();
        const currentUrl = window.location.href;

        const copyFn = (window.UniversalHelpers && typeof window.UniversalHelpers.copyToClipboard === 'function')
            ? window.UniversalHelpers.copyToClipboard.bind(window.UniversalHelpers)
            : null;

        if (!copyFn) {
            // Minimal fallback: try Clipboard API; otherwise show error.
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(currentUrl).then(function () {
                    $copyError.slideUp();
                    $copySuccess.slideDown();
                    setTimeout(function () { $copySuccess.slideUp(); }, 3000);
                }).catch(function () {
                    $copySuccess.slideUp();
                    $copyError.slideDown();
                    setTimeout(function () { $copyError.slideUp(); }, 3000);
                });
            } else {
                $copySuccess.slideUp();
                $copyError.slideDown();
                setTimeout(function () { $copyError.slideUp(); }, 3000);
            }
            return;
        }

        copyFn(currentUrl).then(function () {
            $copyError.slideUp();
            $copySuccess.slideDown();
            setTimeout(function () { $copySuccess.slideUp(); }, 3000);
        }).catch(function () {
            $copySuccess.slideUp();
            $copyError.slideDown();
            setTimeout(function () { $copyError.slideUp(); }, 3000);
        });
    });

    // EMAIL reveal (wheel)
    $root.on('click', '.single-wheel-page .reveal-email', function (e) {
        const $btn = $(this);
        if ($btn.data('revealed')) return; // allow default action

        e.preventDefault();

        const fullEmail = $btn.data('full-email');
        const mailtoLink = $btn.data('mailto-link');
        if (!fullEmail) return;

        $btn.find('.email-text').text(fullEmail);
        if (mailtoLink) {
            $btn.attr('href', mailtoLink);
        }
        $btn.data('revealed', true);
        $btn.removeClass('reveal-email');
    });

    // PHONE reveal (wheel)
    $root.on('click', '.single-wheel-page .reveal-phone', function (e) {
        const $btn = $(this);
        if ($btn.data('revealed')) return; // allow default action

        e.preventDefault();

        const fullPhone = $btn.data('full-phone');
        const telLink = $btn.data('tel-link');
        if (!fullPhone) return;

        $btn.find('.phone-text').text(fullPhone);
        if (telLink) {
            $btn.attr('href', telLink);
        }
        $btn.data('revealed', true);
        $btn.removeClass('reveal-phone');
    });

    // WHATSAPP reveal (wheel)
    $root.on('click', '.single-wheel-page .reveal-whatsapp', function (e) {
        const $btn = $(this);
        e.preventDefault();

        const encodedPhone = $btn.data('wa-phone');
        const encodedText = $btn.data('wa-text');
        if (!encodedPhone) return;

        try {
            const phone = atob(encodedPhone);
            let url = 'https://wa.me/' + phone;
            if (encodedText) {
                const text = atob(encodedText); // server provided URL-encoded text
                url += '?text=' + text;
            }
            window.open(url, '_blank');
        } catch (err) {
            // ignore
        }
    });

    // API fitment browser: lazy-load so Wheel-Size never blocks page render
    const $fitmentSection = $('#single-wheel-fitment-section');
    const fitmentWheelId = $fitmentSection.length
        ? parseInt($fitmentSection.data('wheel-id'), 10)
        : 0;
    let fitmentLoading = false;

    function initFitmentBrowser($root) {
        if (window.CarBuyWheelApiFitmentBrowser) {
            window.CarBuyWheelApiFitmentBrowser.init($root && $root.length ? $root : $('.single-wheel-page'));
        }
        $('.single-wheel-page .wheel-api-fitment-browser').removeClass('before-fade-in');
    }

    function loadPendingWheelFitments() {
        if (!$fitmentSection.length || String($fitmentSection.data('pending')) !== '1' || fitmentLoading) {
            initFitmentBrowser($('.single-wheel-page'));
            return;
        }
        if (!fitmentWheelId) {
            $fitmentSection.remove();
            return;
        }

        fitmentLoading = true;
        $.ajax({
            url: '/ajax/wheels/' + fitmentWheelId + '/fitments',
            method: 'GET',
            dataType: 'json',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).done(function (response) {
            const $host = $fitmentSection.find('[data-wheel-fitment-host]').first();
            const html = response && typeof response.html === 'string' ? response.html.trim() : '';
            if (response && response.available && html) {
                $host.html(html);
                $fitmentSection
                    .removeClass('single-wheel-fitment-pending')
                    .removeAttr('data-pending')
                    .attr('aria-busy', 'false');
                initFitmentBrowser($fitmentSection);
                return;
            }
            $fitmentSection.remove();
        }).fail(function () {
            $fitmentSection.remove();
        }).always(function () {
            fitmentLoading = false;
        });
    }

    loadPendingWheelFitments();
});


